const responseCountryPhoneCode = {
    "payload": [
    {
        "countryPhoneCodeId": 1,
        "countryPhoneCode": 57,
    },
    {
        "countryPhoneCodeId": 2,
        "countryPhoneCode": 58,
    },
    {
        "countryPhoneCodeId": 3,
        "countryPhoneCode": 59,
    }
]
}
export const service = {
    getCountryPhoneCode: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseCountryPhoneCode }), 1000);
    }),
}